// extracted by mini-css-extract-plugin
export var buttons = "bJ_ct";
export var left = "bJ_bG";
export var media = "bJ_hj";
export var right = "bJ_bH";
export var section = "bJ_b";
export var selected = "bJ_bg";
export var signature = "bJ_hh";
export var testimonial = "bJ_hg";
export var text = "bJ_cq";
export var textContainer = "bJ_bM";
export var video = "bJ_gs";